(function () {
  var cfgEl = document.getElementById('lcd-config');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (err) { return; }
  var root = document.getElementById('legends-cart-drawer');
  if (!root) return;
  var lastFocus = null;

  function open() {
    if (root.getAttribute('data-state') !== 'open') { lastFocus = document.activeElement; }
    root.setAttribute('data-state', 'open');
    root.removeAttribute('aria-hidden'); // Carried fix 3: removeAttribute instead of setAttribute('aria-hidden','false')
    document.body.style.overflow = 'hidden';
    // The drawer becomes visible on the line above, but refresh() is async — so on a
    // first open there was nothing in it until the fetch resolved, and nothing ever if
    // the fetch failed. Say "loading" rather than showing an empty box.
    renderLoading();
    API.refresh();
    var c = root.querySelector('.lcd__close'); if (c) c.focus();
    document.addEventListener('keydown', onKey);
  }
  function close() {
    root.setAttribute('data-state', 'closed');
    root.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', onKey);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function onKey(e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var f = root.querySelectorAll('a[href],button,input,select,textarea,[tabindex]:not([tabindex="-1"])');
    f = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-lcd-close]')) close();
    if (e.target.closest('[data-lcd-retry]')) { renderLoading(true); API.refresh(); }
  });

  // Strings are overridable from the Liquid config but must not depend on it — these
  // three were added after the config block shipped, so fall back in code.
  function str(key, fallback) {
    return (CFG.strings && CFG.strings[key]) || fallback;
  }

  // Placeholder while the cart is in flight. Never blanks a cart we already have, or
  // reopening a populated drawer would flicker empty. `force` is for the retry button,
  // where the stale contents are exactly what we are replacing.
  function renderLoading(force) {
    var items = root.querySelector('[data-lcd-items]');
    if (!items) return;
    if (!force && lastCart && lastCart.items && lastCart.items.length) return;
    items.innerHTML = '<p class="lcd__loading">' + esc(str('loading', 'Loading your cart…')) + '</p>';
  }

  // Shown when refresh() rejects. Previously this path only wrote to the console and
  // the customer was left with an empty drawer and no way forward but a page reload.
  function renderError() {
    var items = root.querySelector('[data-lcd-items]');
    if (!items) return;
    items.innerHTML =
      '<div class="lcd__error">' +
        '<p>' + esc(str('errorMsg', 'We could not load your cart.')) + '</p>' +
        '<button type="button" class="lcd__retry" data-lcd-retry>' +
          esc(str('errorRetry', 'Try again')) +
        '</button>' +
      '</div>';
  }

  // Task 2: AJAX helpers + interception
  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      // Same reasoning as getCart: resolving with an error body renders the drawer as
      // though the write succeeded.
      if (!r.ok) throw new Error('cart write failed: HTTP ' + r.status);
      return r.json();
    });
  }
  // sellingPlanId is optional and, where it is given, is the plan the rest of the cart was
  // bought on. Shopify groups line items into shipments by delivery expectation, so a line
  // added without the pre-order plan the frames carry sits in its own "ships now" group and
  // the customer is billed postage twice — UK £7.98 against £3.99, measured at real
  // checkout 2026-08-11. Callers that have no plan to mirror simply omit it.
  function addVariant(variantId, qty, sellingPlanId) {
    var line = { id: variantId, quantity: qty || 1 };
    if (sellingPlanId != null) line.selling_plan = sellingPlanId;
    return postJSON(CFG.routes.cartAdd, { items: [line] })
      .then(function (res) { open(); return res; })
      .catch(function (err) { console.error('[LCD] add to cart failed', err); });
  }

  // Cart icon -> open drawer instead of navigating to /cart
  document.addEventListener('click', function (e) {
    var cartLink = e.target.closest('a.cart');
    if (cartLink && !cartLink.classList.contains('nav-search') && cartLink.getAttribute('href') === CFG.routes.cart) {
      e.preventDefault();
      e.stopPropagation();
      open();
    }
  }, true);

  // Product form submit -> AJAX add + open drawer (supersedes Mila's popup)
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var fd = new FormData(form);
    fetch(CFG.routes.cartAdd, { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () { return addAddon(form, fd); })
      .then(function () { open(); })
      .catch(function () { form.submit(); }); // fallback: native submit on error
  }, true);

  // A ticked add-on on the product form (the low-light lens on the goggle pages, from
  // snippets/legends-goggle-lens.liquid) goes in as its own line once the product is in.
  // It rides the product's selling plan when it accepts that plan, so a pre-ordered goggle
  // and its lens share one delivery group and one postage charge; otherwise it goes in on no
  // plan and the ship-together planner deals with it as it would any in-stock line.
  // Never rejects: a failed add-on must not trip the native-submit fallback above, which
  // would add the product a second time.
  function addAddon(form, fd) {
    var box = form.querySelector('input[data-legends-addon]:checked');
    if (!box) return Promise.resolve();
    var line = { id: Number(box.getAttribute('data-legends-addon')), quantity: Number(fd.get('quantity')) || 1 };
    var plan = fd.get('selling_plan');
    var plans = (box.getAttribute('data-plans') || '').split(',');
    if (plan && plans.indexOf(String(plan)) !== -1) line.selling_plan = Number(plan);
    return postJSON(CFG.routes.cartAdd, { items: [line] })
      .catch(function (err) { console.error('[LCD] add-on add failed', err); });
  }

  // Header cart badge.
  //
  // Mila renders the count once, server-side — sections/header.liquid puts
  // `<div>{{ cart.item_count }}</div>` inside the basket link — and nothing on any AJAX path
  // wrote to it again. Add a frame from a product page and the drawer opened showing the
  // right contents while the header icon still read the count from the last page load, so
  // customers were left unsure the add had worked until they navigated.
  //
  // Driven from cart JSON only. Every cart object this drawer ever holds arrives through
  // getCart() or render(), so hanging the badge off those two costs no extra requests — the
  // AJAX cart endpoints on this store are rate limited hard enough that a speculative
  // /cart.js per update is not free.
  //
  // The value is cart.item_count verbatim, which is exactly what a later server render will
  // print: gift cases are counted, so one frame legitimately reads 2. Live and reloaded
  // badges therefore always agree.
  function badgeParts() {
    var out = [];
    // `.cart` is also on the search link next to it, hence the nav-search exclusion — the
    // same selector theme.js uses for this element.
    Array.prototype.forEach.call(document.querySelectorAll('a.cart'), function (link) {
      if (link.classList.contains('nav-search')) return;
      for (var i = 0; i < link.children.length; i++) {
        if (link.children[i].tagName === 'DIV') { out.push({ link: link, count: link.children[i] }); return; }
      }
    });
    return out;
  }
  function setBadge(n) {
    badgeParts().forEach(function (b) {
      if (b.count.textContent !== String(n)) b.count.textContent = String(n);
      // Text-link nav variants render "Cart " / "Cart (2)" from the same Liquid. Keep it in
      // step, and keep the label itself out of it — it is localised, so it is read back off
      // the element rather than assumed, and stashed so a count in it cannot be mistaken for
      // part of the word on the next pass.
      var label = b.link.querySelector('.text-link');
      if (!label) return;
      var base = label.getAttribute('data-lcd-label');
      if (base == null) {
        base = label.textContent.replace(/\s*\(\s*\d+\s*\)\s*$/, '').trim();
        label.setAttribute('data-lcd-label', base);
      }
      label.textContent = n > 0 ? base + ' (' + n + ')' : base + ' ';
    });
  }
  // Pass-through so it can sit in a promise chain without swallowing the cart.
  function badgeFrom(cart) {
    if (cart && typeof cart.item_count === 'number') setBadge(cart.item_count);
    return cart;
  }

  // Task 3: cart fetch, money format, escape, render, qty/remove
  // The r.ok check matters more than it looks. Without it a non-JSON reply — a 429
  // (this store rate-limits under load), a challenge page, a proxy error — reaches
  // r.json(), which rejects on the HTML body. refresh()'s catch then logged and did
  // nothing else, so the drawer sat blank until the customer reloaded the page.
  function getCart() {
    return fetch(CFG.routes.cartGet, { headers: { 'Accept': 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('cart fetch failed: HTTP ' + r.status);
        return r.json();
      })
      .then(badgeFrom);
  }

  // Legends: one sync pass = ship-together re-dating, then the free-gift lines. Both are
  // pure planners whose ops are run here, sequentially, then the cart is re-read. The
  // re-read between the two is not optional: a re-dated line gets a NEW key from Shopify,
  // and the gift planner picks the twin by the plan the frames are on, so it must see the
  // cart as it is after the moves.
  var syncing = false;
  var syncPending = false;
  function syncFreeCases(cart) {
    if (syncing) { syncPending = true; return Promise.resolve(cart); }
    syncing = true;
    return syncShipTogether(cart)
      .then(syncGifts)
      .then(function (fresh) {
        syncing = false;
        if (syncPending) { syncPending = false; return syncFreeCases(fresh); }
        return fresh;
      }, function (err) {
        syncing = false;
        syncPending = false;
        throw err;
      });
  }

  // Ship together on the latest date (James, 2026-09-16). See legends-ship-together.js.
  //
  // Every fault this feature can hit is a standing condition, not an event: a missing
  // asset, a config that yields nothing, a variant STOQ never attached to the latest
  // offer. syncFreeCases runs on every cart read and renderTogether on every render, so
  // an unguarded warning repeats on each one and buries whatever else is in the console.
  // Each is therefore said ONCE per page, keyed by what it is.
  var stWarned = {};
  function shipTogetherWarn(code, msg) {
    if (stWarned[code]) return;
    stWarned[code] = true;
    console.warn(msg);
  }
  function shipTogetherEnabled() {
    if (!CFG.shipTogether || !CFG.shipTogether.enabled) return false;
    if (!window.LegendsShipTogether) {
      shipTogetherWarn('module', '[LCD] ship-together is enabled but window.LegendsShipTogether is missing: ' +
        'legends-ship-together.js did not load, or this asset was overwritten. Mixed carts will pay postage twice.');
      return false;
    }
    return true;
  }
  // STOQ not being on the page at all is not a fault: no pre-order app means no dated
  // plans and nothing to unify, so that case stays quiet. STOQ's config being PRESENT and
  // yielding no usable plan is a fault - every offer disabled, or the config shape moved
  // under us - and it turns the whole feature into a silent no-op, so say so.
  function shipTogetherPlans() {
    var plans = window.LegendsShipTogether.plansFromStoq(window._RestockRocketConfig);
    if (!plans.length && window._RestockRocketConfig) {
      shipTogetherWarn('stoq', '[LCD] ship-together: the STOQ plan config is on the page but no usable plan came ' +
        'out of it (every offer disabled, or the config shape changed). Nothing will be re-dated and a mixed ' +
        'cart will still pay postage twice.');
    }
    return plans;
  }
  function shipTogetherPlan(cart) {
    return window.LegendsShipTogether.computeShipTogetherOps(cart, shipTogetherPlans(), { locale: CFG.locale });
  }
  function runShipTogetherOp(op) {
    return postGiftJSON(CFG.routes.cartChange, {
      id: op.key, quantity: op.quantity, selling_plan: op.sellingPlanId, properties: op.properties
    });
  }
  function syncShipTogether(cart) {
    if (!shipTogetherEnabled()) return Promise.resolve(cart);
    var result;
    try { result = shipTogetherPlan(cart); }
    catch (e) { console.error('[LCD] ship-together plan failed', e); return Promise.resolve(cart); }
    if (result.targetPlanId != null && !result.unified) {
      // A line cannot take the latest plan because its variant is not attached to that
      // offer. Nothing to do in the browser; the fix is in STOQ (attach it). Say so.
      shipTogetherWarn('split', '[LCD] ship-together: not every pre-order line can join plan ' + result.targetPlanId +
        '; this cart will still ship in more than one group.');
    }
    if (!result.ops.length) return Promise.resolve(cart);
    // Sequential for the same reason the gift ops are, and the cart is re-read at the end
    // because every line this moved has just been given a new key by Shopify: the gift
    // sync runs next and would otherwise plan against keys that no longer exist.
    var chain = Promise.resolve();
    result.ops.forEach(function (op) {
      chain = chain.then(function () {
        return runShipTogetherOp(op).catch(function (err) {
          console.error('[LCD] ship-together op failed', op, err);
        });
      });
    });
    // .catch AFTER .then(getCart), not an onRejected argument to it: the re-read is the
    // half of this that the gift sync depends on, and a two-argument then would leave a
    // failed getCart uncaught. Same shape as syncGifts, one retry, then give up.
    return chain
      .then(getCart)
      .catch(function (err) { console.error('[LCD] ship-together sync failed', err); return getCart(); });
  }

  // Legends free-case promo: keep gift lines in step with frame lines.
  function syncGifts(cart) {
    if (!window.LegendsFreeCase || !CFG.freeCase || !CFG.freeCase.enabled) {
      // The promo being switched off is a normal, quiet no-op. The promo being switched ON while
      // its dependency is missing is a fault, and it used to be completely silent - on 2026-08-06
      // an unrelated push overwrote this asset and deleted the whole free-case block, so cases
      // simply stopped being added with no error anywhere. Say so.
      if (CFG.freeCase && CFG.freeCase.enabled && !window.LegendsFreeCase) {
        console.warn('[LCD] free-case promo is enabled but window.LegendsFreeCase is missing — ' +
          'legends-free-case.js did not load, or this asset was overwritten. No free gifts will be added.');
      }
      return Promise.resolve(cart);
    }
    var ops;
    try { ops = window.LegendsFreeCase.computeCaseSyncOps(cart, CFG.freeCase); }
    catch (e) { console.error('[LCD] free-case sync failed', e); return Promise.resolve(cart); }
    if (!ops.length) return Promise.resolve(cart);
    // Sequential, not parallel: concurrent cart writes race and Shopify
    // returns the cart as of each individual write. Each op catches its own
    // failure (logged, not silent) so one bad op - e.g. an add for a variant
    // not published to the customer's market - can't abort ops queued behind
    // it, notably the orphan-removal ops computeCaseSyncOps emits last.
    var chain = Promise.resolve();
    ops.forEach(function (op) {
      chain = chain.then(function () {
        return runGiftOp(op).catch(function (err) {
          console.error('[LCD] free-case op failed', op, err);
        });
      });
    });
    return chain
      .then(getCart)
      .catch(function (err) { console.error('[LCD] free-case sync failed', err); return getCart(); });
  }
  function runGiftOp(op) {
    if (op.type === 'add') {
      var item = {
        id: op.variantId,
        quantity: op.quantity,
        properties: makeGiftProps()
      };
      // Mirror the frame's pre-order plan onto the gift at the moment it is added.
      // Shopify groups line items into shipments by delivery expectation, so a gift
      // with no plan sits in its own "ships now" group against the frame's dated one
      // and the customer is billed postage twice (UK £7.98 vs £3.99, measured at real
      // checkout 2026-08-11). STOQ's cart script does restamp the line a moment later,
      // but that leaves a window where the cart is wrong and depends on the app.
      if (op.sellingPlanId != null) item.selling_plan = op.sellingPlanId;
      return postGiftJSON(CFG.routes.cartAdd, { items: [item] });
    }
    return postGiftJSON(CFG.routes.cartChange, { id: op.key, quantity: op.quantity });
  }
  // Own POST helper (not the shared postJSON): a failed write must reject so
  // runGiftOp's caller can log it, instead of silently resolving with an
  // error body and rendering as if the case were added.
  function postGiftJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw r; return r.json(); });
  }
  // The property is a plain marker rather than the band tag it carried before 2026-08-26.
  // Band-matching came back on 2026-09-22 but the marker did not: staleness is decided on
  // the variant, and a gift line left over from an older shape of the promo has to be
  // recognisable whatever its band said. It only has to be non-blank: cart-item.liquid and
  // the drawer both gate the locked-line rendering on its presence.
  function makeGiftProps() {
    var p = {};
    p[window.LegendsFreeCase.GIFT_PROP] = window.LegendsFreeCase.GIFT_MARK || '1';
    return p;
  }

  // syncFreeCases only runs on drawer open and on mutations the drawer itself made. The
  // /cart page has its own quantity controls and its own checkout button, both outside
  // this drawer, so a quantity change made there never reached the sync and the gift
  // lines went stale in BOTH directions - three frames cut to one left three free cases
  // in the cart, £45 given away straight into checkout.
  var CART_RESYNC_FLAG = 'lcd:cart-resynced';
  function onCartPage() {
    if (document.body && document.body.classList.contains('template-cart')) return true;
    // Fallback for markets/locales whose cart route is prefixed: compare against the
    // localised route Liquid handed us rather than a hardcoded '/cart'.
    var here = location.pathname.replace(/\/+$/, '');
    var cartRoute = String(CFG.routes.cart || '/cart').replace(/\/+$/, '');
    return here === cartRoute;
  }
  // Line keys and quantities are what the gift ops move, so this is enough to tell
  // "the sync actually wrote something" from "the cart was already correct".
  function cartFingerprint(cart) {
    var items = cart && cart.items ? cart.items : [];
    return items.map(function (it) { return it.key + ':' + it.quantity; }).join('|');
  }
  // Runs the ordinary sync; resolves true only if it actually wrote to the cart.
  function resyncCartPage() {
    return getCart().then(function (before) {
      return syncFreeCases(before).then(function (after) {
        return cartFingerprint(before) !== cartFingerprint(after);
      });
    }).catch(function (err) {
      console.error('[LCD] cart page free-case resync failed', err);
      return false;
    });
  }
  // The /cart lines are server-rendered, so after the sync writes they still show the old
  // quantities. One reload puts the page back in step. The flag survives that reload and
  // stops the arrival resync from starting another one, so this cannot loop. With no
  // sessionStorage there is nothing to bound a loop with, so decline the reload instead -
  // the cart itself is already correct by then, only the page is behind.
  function reloadCartPage() {
    try { sessionStorage.setItem(CART_RESYNC_FLAG, '1'); } catch (e) { return; }
    location.reload();
  }
  function initCartPageResync() {
    if (!onCartPage()) return;
    // Mila changes /cart quantities over AJAX (cart-form[data-ajax-update]) and announces it
    // with theme:cartchanged, so there is no page load to hang this off. That event is what
    // the gift lines actually have to follow - it is the £45-into-checkout path.
    document.addEventListener('theme:cartchanged', function () {
      resyncCartPage().then(function (changed) { if (changed) reloadCartPage(); });
    });
    // Plus a resync on arrival, for a cart left stale by an earlier visit or another tab.
    var justReloaded = false;
    try {
      justReloaded = sessionStorage.getItem(CART_RESYNC_FLAG) === '1';
      sessionStorage.removeItem(CART_RESYNC_FLAG);
    } catch (e) { /* no sessionStorage: reloadCartPage declines anyway, nothing to guard */ }
    resyncCartPage().then(function (changed) {
      if (!changed) return;
      if (justReloaded) {
        console.warn('[LCD] free-case sync still changed the cart after a reload — not reloading again.');
        return;
      }
      reloadCartPage();
    });
  }

  // theme:cartchanged is Mila's own "the cart just changed" signal, dispatched by the /cart
  // page quantity controls (assets/theme.js). On /cart the resync above already re-reads the
  // cart on that event and the badge follows from getCart(), so listening here as well would
  // only buy a second /cart.js for the same change. Off the cart page nothing else re-reads,
  // so the listener earns its keep there.
  function initBadgeSync() {
    if (onCartPage()) return;
    document.addEventListener('theme:cartchanged', function () {
      getCart().catch(function (err) { console.error('[LCD] cart badge update failed', err); });
    });
  }

  function changeLine(key, qty) {
    return postJSON(CFG.routes.cartChange, { id: key, quantity: qty }).then(syncFreeCases).then(render).catch(function (err) { console.error('[LCD] cart change failed', err); });
  }
  function formatMoney(cents) {
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: CFG.currency }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  // Legends Rx: prescription capture on lines carrying the prescription flag.
  // Lens lab limits confirmed 2026-08-06: Rx lenses run -8.00 to +8.00 sphere
  // with cylinder up to 6.00, polarised and non-polarised alike (the tighter
  // -4.00/+4.00 range applies only to stock lenses, which we do not sell).
  // Anything beyond needs a manual quote, so it is blocked here rather than
  // taken as an order we cannot fill.
  var RX_MAX_SPH = 8;
  var RX_MAX_CYL = 6;
  var RX_MIN_PD = 45;
  var RX_MAX_PD = 80;

  // Customer-facing Rx text comes from the theme locale (CFG.strings, built in
  // snippets/legends-cart-drawer.liquid) so /es/, /de/ and /pt/ read in their own
  // language. The English fallback is the original wording, and it keeps this block
  // self-contained: tests/rx-validation.test.js evaluates it on its own, without CFG.
  // {name} placeholders are filled from vars.
  function rxS(key, fallback, vars) {
    var s = (typeof CFG !== 'undefined' && CFG && CFG.strings && CFG.strings[key]) || fallback;
    if (vars) Object.keys(vars).forEach(function (k) { s = s.split('{' + k + '}').join(vars[k]); });
    return s;
  }

  // An unsigned sphere is not a sphere. On order LOE-1310 the customer typed
  // "1,25" and the real prescription was -0.75: a missing sign is the difference
  // between long and short sight, and nothing downstream can recover it. So the
  // sign is required here rather than guessed at later.
  var RX_SIGNED = /^[+-] ?(?:\d+(?:[.,]\d+)?|[.,]\d+)$/;

  // An eye that needs no correction is a real prescription, not a missing one, and
  // it is written plano. Zero is the one value where a sign means nothing, so the
  // sign requirement below is waived for it.
  var RX_PLANO = /^(?:pl|plano)$/i;

  // Prescriptions get pasted out of opticians' PDFs, which use every dash in
  // Unicode. Fold them all to a plain hyphen before anything looks at the value.
  function rxClean(v) {
    return String(v == null ? '' : v)
      .replace(/[\u2010-\u2015\u2212]/g, '-')
      .replace(/\s+/g, ' ')
      .trim();
  }
  function rxRaw(wrap, sel) {
    var el = wrap.querySelector('[data-rx="' + sel + '"]');
    return el ? rxClean(el.value) : '';
  }
  function rxNum(v) {
    var t = rxClean(v);
    if (t === '') return null;
    if (RX_PLANO.test(t)) return 0;
    var n = parseFloat(t.replace(',', '.').replace(/[^0-9.+-]/g, ''));
    return isNaN(n) ? null : n;
  }
  // Optical convention: always signed, always two decimals. Storing "+0.50"
  // rather than "+.50" removes a whole class of downstream parsing doubt.
  // Zero is written unsigned, because "+0.00" and "-0.00" are the same thing.
  function rxFmt(n) { return n === 0 ? '0.00' : (n < 0 ? '-' : '+') + Math.abs(n).toFixed(2); }

  // True once the customer has put anything at all in the form. Used to tell a
  // deliberate "I have my prescription" apart from an untouched block, which
  // still falls through to "To follow (emailed)".
  function rxTouched(wrap) {
    var any = false;
    ['R-SPH', 'R-CYL', 'R-AXIS', 'L-SPH', 'L-CYL', 'L-AXIS', 'PD'].forEach(function (k) {
      if (rxRaw(wrap, k) !== '') any = true;
    });
    return any;
  }

  function rxErrors(wrap) {
    var errs = [];
    ['R', 'L'].forEach(function (side) {
      var eye = { eye: side === 'R' ? rxS('rxEyeRight', 'Right eye') : rxS('rxEyeLeft', 'Left eye') };
      var sphRaw = rxRaw(wrap, side + '-SPH');
      var cylRaw = rxRaw(wrap, side + '-CYL');
      var axisRaw = rxRaw(wrap, side + '-AXIS');

      if (sphRaw === '') {
        errs.push(rxS('rxErrSphMissing', '{eye}: enter the sphere (SPH), or just 0 if this eye needs no correction.', eye));
      } else {
        var sph = rxNum(sphRaw);
        if (sph === null) {
          errs.push(rxS('rxErrSphNan', '{eye}: the sphere should be a number, or just 0 for no correction.', eye));
        } else if (sph !== 0 && !RX_SIGNED.test(sphRaw)) {
          errs.push(rxS('rxErrSphSign', '{eye}: put a + or - in front of the sphere, for example -2.00 or +1.25.', eye));
        } else if (Math.abs(sph) > RX_MAX_SPH) {
          errs.push(rxS('rxErrSphLimit', '{eye}: we can only make up to -8.00 or +8.00.', eye));
          errs.overLimit = true;
        }
      }

      var cyl = null;
      if (cylRaw !== '') {
        cyl = rxNum(cylRaw);
        if (cyl === null) {
          errs.push(rxS('rxErrCylNan', '{eye}: the cylinder should be a number, or left blank for no astigmatism.', eye));
        } else if (cyl !== 0 && !RX_SIGNED.test(cylRaw)) {
          errs.push(rxS('rxErrCylSign', '{eye}: put a + or - in front of the cylinder, for example -0.50.', eye));
        } else if (Math.abs(cyl) > RX_MAX_CYL) {
          errs.push(rxS('rxErrCylLimit', '{eye}: we can only make astigmatism up to 6.00.', eye));
          errs.overLimit = true;
        }
      }

      // A cylinder cannot be glazed without an axis, and an axis means nothing
      // without a cylinder. A zero cylinder is neither, and is dropped on save.
      if (cyl !== null && Math.abs(cyl) > 0) {
        if (axisRaw === '') {
          errs.push(rxS('rxErrAxisMissing', '{eye}: a cylinder needs an axis.', eye));
        } else {
          var ax = rxNum(axisRaw);
          if (ax === null || ax < 0 || ax > 180 || ax !== Math.round(ax)) {
            errs.push(rxS('rxErrAxisRange', '{eye}: the axis must be a whole number between 0 and 180.', eye));
          }
        }
      } else if (axisRaw !== '' && rxNum(axisRaw) !== 0) {
        // A real axis with nothing to apply it to means one of the two was
        // mistyped, and guessing which would be guessing at the prescription.
        // A zero axis beside a zero or blank cylinder is just the customer
        // writing out "no astigmatism" longhand, which is fine: both get
        // dropped on save. Order LOE-1261 arrived exactly that way.
        errs.push(rxS('rxErrAxisOrphan', '{eye}: there is an axis but no cylinder to go with it.', eye));
      }
    });

    // Without a PD the lab cannot centre the lenses, so the pair cannot be made.
    // Order LOE-1281 reached us with a full prescription and no PD at all.
    var pdRaw = rxRaw(wrap, 'PD');
    if (pdRaw === '') {
      errs.push(rxS('rxErrPdMissing', 'Enter your PD. We cannot make the lenses up without it.'));
    } else {
      var pd = rxNum(pdRaw);
      if (pd === null || pd < RX_MIN_PD || pd > RX_MAX_PD) {
        errs.push(rxS('rxErrPdRange', 'The PD should be a number between {min} and {max}.', { min: RX_MIN_PD, max: RX_MAX_PD }));
      }
    }
    return errs;
  }

  // Build one eye's stored string from validated input, normalised.
  function rxEye(wrap, side) {
    var out = [];
    var sph = rxNum(rxRaw(wrap, side + '-SPH'));
    if (sph === null) return '';
    out.push('SPH ' + rxFmt(sph));
    var cyl = rxNum(rxRaw(wrap, side + '-CYL'));
    // A zero cylinder is not a cylinder. Order LOE-1261 stored "CYL +0.00,
    // AXIS 0", which reads downstream as a real instruction rather than as the
    // "no astigmatism" the customer meant. Drop it instead.
    if (cyl !== null && Math.abs(cyl) > 0) {
      out.push('CYL ' + rxFmt(cyl));
      var ax = rxNum(rxRaw(wrap, side + '-AXIS'));
      if (ax !== null) out.push('AXIS ' + String(Math.round(ax)));
    }
    return out.join(', ');
  }
  function hasRx(it) {
    if (/\bRX\b/i.test(it.variant_title || '')) return true;
    return !!(it.properties && it.properties['Prescription lenses']);
  }
  function rxRow(side) {
    var shown = { side: side === 'R' ? str('rxSideR', 'R') : str('rxSideL', 'L') };
    return '<span class="lcd-rx__side">' + esc(shown.side) + '</span>' +
      '<input type="text" data-rx="' + side + '-SPH" placeholder="-2.00" aria-label="' + esc(rxS('rxAriaSph', '{side} sphere', shown)) + '">' +
      '<input type="text" data-rx="' + side + '-CYL" placeholder="-0.50" aria-label="' + esc(rxS('rxAriaCyl', '{side} cylinder', shown)) + '">' +
      '<input type="text" inputmode="numeric" data-rx="' + side + '-AXIS" placeholder="180" aria-label="' + esc(rxS('rxAriaAxis', '{side} axis', shown)) + '">';
  }
  // 'Rx status' is stored in English for the back office. Show the customer their language.
  function rxStatusLabel(status) {
    if (status === 'To follow (emailed)') return str('rxStatusLater', status);
    if (status === 'Provided') return str('rxStatusProvided', status);
    return status;
  }
  function rxBlock(it) {
    if (!hasRx(it)) return '';
    var p = it.properties || {};
    var key = esc(it.key);
    var status = p['Rx status'];
    if (status) {
      var summary;
      if (status === 'To follow (emailed)') {
        summary = esc(str('rxLaterSummary', "We'll email you to collect your prescription."));
      } else {
        var rows = [esc(str('rxSideR', 'R')) + ':  ' + esc(p['Rx (R)'] || '-'), esc(str('rxSideL', 'L')) + ':  ' + esc(p['Rx (L)'] || '-')];
        if (p['PD']) rows.push('PD:  ' + esc(p['PD']));
        summary = rows.join('<br>');
      }
      return '<div class="lcd-rx lcd-rx--done" data-rx-key="' + key + '">' +
        '<span class="lcd-rx__tick">✓</span><span class="lcd-rx__saved">' + esc(rxStatusLabel(status)) + '</span>' +
        '<button type="button" class="lcd-rx__edit" data-lcd-rx-edit>' + esc(str('rxEdit', 'Edit')) + '</button>' +
        '<span class="lcd-rx__sum">' + summary + '</span></div>';
    }
    return '<details class="lcd-rx" data-rx-key="' + key + '" open>' +
      '<summary class="lcd-rx__q">' + esc(str('rxQuestion', 'Have a prescription handy?')) + '</summary>' +
      '<div class="lcd-rx__body">' +
        '<div class="lcd-rx__grid">' +
          '<span class="lcd-rx__h"></span><span class="lcd-rx__h">' + esc(str('rxHSph', 'SPH')) + '</span><span class="lcd-rx__h">' + esc(str('rxHCyl', 'CYL')) + '</span><span class="lcd-rx__h">' + esc(str('rxHAxis', 'AXIS')) + '</span>' +
          rxRow('R') + rxRow('L') +
        '</div>' +
        '<label class="lcd-rx__pd">' + esc(str('rxPdLabel', 'PD (required)')) + ' <input type="text" inputmode="decimal" data-rx="PD" placeholder="' + esc(str('rxPdPlaceholder', 'e.g. 63')) + '"></label>' +
        '<p class="lcd-rx__limits">' + esc(str('rxLimits', 'Copy your prescription exactly, including the + or - in front of each number. Enter 0 for an eye that needs no correction, and leave CYL and AXIS blank if there is no astigmatism. We can make prescriptions from -8.00 to +8.00, with astigmatism up to 6.00.')) + '</p>' +
        '<div class="lcd-rx__later-row">' +
          '<label class="lcd-rx__later"><input type="checkbox" data-rx-later> ' + esc(str('rxLater', "I'll provide it later")) + ' <span class="lcd-rx__later-note">' + esc(str('rxLaterNote', "(we'll email you after you place your order)")) + '</span></label>' +
        '</div>' +
        '<p class="lcd-rx__err" data-lcd-rx-err hidden></p>' +
        '<button type="button" class="lcd-rx__save" data-lcd-rx-save>' + esc(str('rxSave', 'Save prescription')) + '</button>' +
      '</div></details>';
  }
  // /cart/change.js REPLACES a line's properties wholesale, so posting only the Rx keys
  // deleted everything else the line was carrying — including the "Shipping: Aug 24, 2026"
  // date STOQ stamps on every pre-order line. Saving a prescription silently dropped the
  // customer's ship date. Merge instead: keep whatever the line already has, and let this
  // form own only the keys it writes.
  //
  // Rx-owned keys are listed so that clearing them still works: pressing Edit posts {},
  // which must remove the saved prescription without touching Shipping, _free_case, or
  // "Prescription lenses" (which marks the line as Rx in the first place and is not ours).
  var RX_OWNED_PROPS = ['Rx status', 'Rx (R)', 'Rx (L)', 'PD'];
  function mergeLineProps(existing, props) {
    var out = {}, k;
    for (k in existing) {
      if (!Object.prototype.hasOwnProperty.call(existing, k)) continue;
      if (RX_OWNED_PROPS.indexOf(k) !== -1) continue;
      out[k] = existing[k];
    }
    for (k in props) {
      if (Object.prototype.hasOwnProperty.call(props, k)) out[k] = props[k];
    }
    return out;
  }
  function lineByKey(cart, key) {
    var items = cart && cart.items ? cart.items : [];
    for (var i = 0; i < items.length; i++) { if (items[i] && items[i].key === key) return items[i]; }
    return null;
  }
  // The drawer renders from a cart it already holds, so no extra request in the normal
  // case; re-read only if that line is not in the cart we last rendered.
  function existingLineProps(key) {
    var it = lineByKey(lastCart, key);
    if (it) return Promise.resolve(it.properties || {});
    return getCart().then(function (fresh) {
      var l = lineByKey(fresh, key);
      return (l && l.properties) || {};
    });
  }
  function updateLineProps(key, qty, props) {
    return existingLineProps(key)
      .then(function (existing) {
        return postJSON(CFG.routes.cartChange, { id: key, quantity: qty, properties: mergeLineProps(existing, props) });
      })
      .then(syncFreeCases).then(render).catch(function (err) { console.error('[LCD] rx save failed', err); });
  }

  var lastCart = null;  // the cart the drawer last rendered from; source for property merges
  function render(cart) {
    lastCart = cart;
    badgeFrom(cart);  // /cart/change.js replies with the whole cart, so this needs no fetch
    var items = root.querySelector('[data-lcd-items]');
    var count = root.querySelector('[data-lcd-count]');
    var subtotal = root.querySelector('[data-lcd-subtotal]');
    count.textContent = cart.item_count;
    subtotal.textContent = formatMoney(cart.total_price);
    if (!cart.items.length) {
      items.innerHTML = '<p class="lcd__empty">' + esc(CFG.strings.empty) + '</p>';
    } else {
      items.innerHTML = cart.items.map(function (it) {
        var img = it.featured_image && it.featured_image.url ? it.featured_image.url.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : '';
        var thumb = img ? '<img class="lcd__thumb" src="' + esc(img) + '" alt="" loading="lazy">' : '<span class="lcd__thumb"></span>';
        var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<div class="lcd__var">' + esc(it.variant_title) + '</div>' : '';
        var giftProp = window.LegendsFreeCase ? window.LegendsFreeCase.GIFT_PROP : '_free_case';
        var isGift = !!(CFG.freeCase && CFG.freeCase.enabled && it.properties && it.properties[giftProp]);
        if (isGift) {
          // Locked line: no quantity stepper, no remove button — the sync owns this
          // line's quantity, so the customer must not be offered controls for it.
          //
          // The price is read from the cart, NOT hardcoded to "FREE". Claiming free
          // while Shopify charges for it is the worst failure this drawer can have,
          // so if the discount has not applied the customer sees the real amount.
          var giftQty = it.quantity > 1 ? ' <span class="lcd__gift-qty">&times;' + it.quantity + '</span>' : '';
          var giftIsFree = it.final_line_price === 0;
          var giftPrice = giftIsFree
            ? '<s>' + formatMoney(it.original_line_price) + '</s> ' +
              '<strong>' + esc(CFG.strings.freeCaseFree) + '</strong>'
            : formatMoney(it.final_line_price);
          // The "Free with your pre-order" tag is gated on the same fact as the price:
          // the line actually costing nothing. It used to render on every line carrying
          // the gift property, so a line the discount had not reached showed its real
          // price and a label calling it free. Showing the price with no tag is the
          // honest failure state; the planner's stale-gift heal fixes the cause.
          // Which promise the tag makes depends on the LINE, not on the promo. Since
          // 2026-09-22 an AC/DC case is earned by an in-stock pair and arrives with no
          // selling plan, so "Free with your pre-order" would be a plain untruth on it. A
          // line carrying a plan is one the customer is waiting for, whether they chose
          // that date or legends-ship-together.js moved them onto it.
          var giftOnPlan = !!(it.selling_plan_allocation && it.selling_plan_allocation.selling_plan);
          var giftTagText = giftOnPlan
            ? CFG.strings.freeCaseTag
            : (CFG.strings.freeCaseTagOrder || CFG.strings.freeCaseTag);
          var giftTag = giftIsFree
            ? '<div class="lcd__gift-tag">' + esc(giftTagText) + '</div>'
            : '';
          return '<div class="lcd__item lcd__item--gift" data-key="' + esc(it.key) + '">' +
            thumb +
            '<div class="lcd__info"><span class="lcd__name">' + esc(it.product_title) + giftQty + '</span>' +
              giftTag + '</div>' +
            '<div class="lcd__line"><span class="lcd__gift-price">' + giftPrice + '</span></div>' +
            '</div>';
        }
        return '<div class="lcd__item" data-key="' + esc(it.key) + '">' +
          thumb +
          '<div class="lcd__info"><a class="lcd__name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant +
            '<div class="lcd__qty"><button data-lcd-dec aria-label="' + esc(str('ariaDecrease', 'Decrease')) + '">&minus;</button>' +
            '<span>' + it.quantity + '</span><button data-lcd-inc aria-label="' + esc(str('ariaIncrease', 'Increase')) + '">+</button></div></div>' +
          '<div class="lcd__line"><button class="lcd__rm" data-lcd-rm aria-label="' + esc(str('ariaRemove', 'Remove')) + '">&times;</button>' +
            '<span>' + formatMoney(it.final_line_price) + '</span></div>' +
          rxBlock(it) + '</div>';
      }).join('');
    }
    if (window.LCD_afterRender) window.LCD_afterRender(cart); // hook for ship bar / discount / recs
  }

  function refresh() {
    return getCart().then(syncFreeCases).then(render).catch(function (err) {
      console.error('[LCD] cart refresh failed', err);
      renderError();
    });
  }

  root.querySelector('[data-lcd-items]').addEventListener('click', function (e) {
    var itemEl = e.target.closest('.lcd__item'); if (!itemEl) return;
    var key = itemEl.getAttribute('data-key');
    var qtyEl = itemEl.querySelector('.lcd__qty span');
    if (!qtyEl) return;  // gift lines have no stepper
    var qty = parseInt(qtyEl.textContent, 10);
    if (e.target.closest('[data-lcd-inc]')) changeLine(key, qty + 1);
    else if (e.target.closest('[data-lcd-dec]')) changeLine(key, Math.max(0, qty - 1));
    else if (e.target.closest('[data-lcd-rm]')) changeLine(key, 0);
  });

  // Legends Rx: save / edit prescription details on a line item
  root.querySelector('[data-lcd-items]').addEventListener('click', function (e) {
    var saveBtn = e.target.closest('[data-lcd-rx-save]');
    if (saveBtn) {
      e.preventDefault();
      var wrap = saveBtn.closest('[data-rx-key]');
      var itemEl = saveBtn.closest('.lcd__item');
      var key = wrap.getAttribute('data-rx-key');
      var qty = parseInt(itemEl.querySelector('.lcd__qty span').textContent, 10) || 1;
      var later = wrap.querySelector('[data-rx-later]');
      var props = {};
      var errEl = wrap.querySelector('[data-lcd-rx-err]');
      var isLater = !!(later && later.checked);
      var touched = rxTouched(wrap);

      // Three routes out of here: the customer opted to send it on later, they
      // left the block alone, or they actually filled it in. Only the last is
      // validated, and it is validated in full. A half-entered prescription is
      // worse than none, because it looks like we have one when we do not.
      if (!isLater && touched) {
        var errs = rxErrors(wrap);
        if (errs.length) {
          if (errEl) {
            var msg = errs.map(esc).join('<br>');
            if (errs.overLimit) {
              msg += '<br>' + esc(str('rxErrContact', 'Please get in touch and we will let you know what we can do.'));
            }
            errEl.innerHTML = msg;
            errEl.hidden = false;
          }
          return;
        }
      }
      if (errEl) errEl.hidden = true;

      if (isLater || !touched) {
        props['Rx status'] = 'To follow (emailed)';
      } else {
        props['Rx status'] = 'Provided';
        var r = rxEye(wrap, 'R');
        var l = rxEye(wrap, 'L');
        var pd = rxNum(rxRaw(wrap, 'PD'));
        if (r) props['Rx (R)'] = r;
        if (l) props['Rx (L)'] = l;
        if (pd !== null) props['PD'] = String(pd);
      }
      updateLineProps(key, qty, props);
      return;
    }
    var editBtn = e.target.closest('[data-lcd-rx-edit]');
    if (editBtn) {
      e.preventDefault();
      var w = editBtn.closest('[data-rx-key]');
      var iEl = editBtn.closest('.lcd__item');
      var k = w.getAttribute('data-rx-key');
      var q = parseInt(iEl.querySelector('.lcd__qty span').textContent, 10) || 1;
      updateLineProps(k, q, {});
      return;
    }
  });

  // Task 4: market-aware free-shipping progress bar.
  // The threshold is resolved per COUNTRY in that country's own currency by
  // snippets/legends-free-ship-map.liquid, and the decision lives in
  // legends-ship-bar.js. Countries whose zone has no free-shipping rate get no
  // entry and therefore no bar — see that file for why there is no fallback.
  function renderShip(cart) {
    var el = root.querySelector('[data-lcd-ship]');
    if (!el) return;
    if (!window.LegendsShipBar) {
      console.warn('[LCD] legends-ship-bar.js did not load — free-shipping bar suppressed.');
      el.hidden = true;
      return;
    }
    var state = window.LegendsShipBar.freeShipState(cart, CFG.freeShip, CFG.currency);
    if (!state.show) { el.hidden = true; return; }
    el.hidden = false;
    var msg = state.unlocked
      ? CFG.strings.freeShipUnlocked
      : CFG.strings.freeShipProgress.replace('{{ amount }}', '<strong>' + formatMoney(state.remaining) + '</strong>');
    el.innerHTML = '<p class="lcd__ship-msg">' + msg + '</p>' +
      '<div class="lcd__ship-track"><div class="lcd__ship-fill" style="width:' + state.pct + '%"></div></div>';
  }
  // "Your whole order ships together. Shipping: early November". Rendered from the cart
  // actually read back, never from the plan: the planner is run again on this cart and
  // the line shows only when it has nothing left to do (every line already on the latest
  // plan) and something WAS moved to get there. A cart that never mixed dates says
  // nothing; a cart with a line that cannot join says nothing, which is the honest state.
  //
  // The whole body runs inside a try/catch. renderDiscount and renderUpsells follow this
  // in LCD_afterRender, so a throw here would take the discount field and the upsell row
  // down with it: a cosmetic line would have cost the customer the controls underneath it.
  function renderTogether(cart) {
    var el = null;
    try {
      el = root.querySelector('[data-lcd-together]');
      if (!el) return;
      el.hidden = true;
      el.innerHTML = '';
      if (!shipTogetherEnabled() || !cart || !cart.items || !cart.items.length) return;
      var plans = shipTogetherPlans();
      var result = shipTogetherPlan(cart);
      // A cart nothing had to be moved in still gets its date (James, 2026-10-26): a pair of
      // pre-ordered sunglasses on its own used to show no date anywhere in the drawer.
      if (result.ops.length || !result.unified) return;
      /* The claim is checked against the rendered cart itself, not against the plan: every
         line has to be in the SAME delivery group, which means every line on the same
         selling plan AND no line without one. A line with no plan is not a harmless
         in-stock extra here: Shopify ships it now, in its own group, with its own postage,
         which is the exact charge this feature exists to prevent. Gift lines count too,
         since the gift planner runs after the re-dating and could have left a twin behind
         on the earlier date. */
      var seen = [], alloc, id, key, planless = false;
      for (var j = 0; j < cart.items.length; j++) {
        alloc = cart.items[j] && cart.items[j].selling_plan_allocation;
        id = alloc && alloc.selling_plan ? alloc.selling_plan.id : null;
        if (id == null) planless = true;
        key = id == null ? 'none' : String(id);
        if (seen.indexOf(key) === -1) seen.push(key);
      }
      if (planless || seen.length > 1) {
        // Withholding the notice is the honest thing to do, but silently withholding it
        // leaves a defeated feature looking exactly like a working one. Once per page,
        // named by the plans actually seen ('none' being a line with no plan at all).
        shipTogetherWarn('split-render',
          '[LCD] ship-together: the cart was re-dated but is still not one delivery group, so the notice is ' +
          'withheld. Selling plans on the rendered lines: ' + seen.join(', ') + '. A gift twin left on the ' +
          'earlier plan, or a line with no plan at all, is a second delivery group and a second postage charge.');
        return;
      }
      /* The date to name is the plan the date came from, which is not always the plan the
         lines sit on: a basket carried on November because of a flight case ships late
         November (datePlanId), and saying "early November" here would be the one place the
         cart contradicts its own lines. */
      var dateFrom = result.datePlanId != null ? result.datePlanId : result.targetPlanId;
      var latest = null;
      for (var i = 0; i < plans.length; i++) {
        if (String(plans[i].id) === String(dateFrom)) { latest = plans[i]; break; }
      }
      if (!latest) return;
      /* Three different sentences, because the cart is in one of three situations. A
         basket that mixed pre-order DATES is simply told everything arrives together. A
         basket that mixed STOCK with a pre-order is told why it is waiting and what to take
         out to stop waiting, which is the only version of this the customer can act on.
         A basket whose pre-orders already shared one date is just told the date.
         `joined` is the count of lines that had no date of their own. */
      var mixedWithStock = result.joined > 0;
      var mixedDates = !mixedWithStock && result.redated > 0;
      var shipping = mixedDates
        ? window.LegendsShipTogether.shippingText(latest, CFG.locale)
        : window.LegendsShipTogether.shippingValue(latest, CFG.locale);
      // A function replacement, not a string one: String.prototype.replace reads $&, $1, $`
      // and $' inside a string replacement as references, so a ship phrase STOQ happened to
      // write with a $ in it would rewrite the sentence around it. A function's return value
      // is substituted verbatim.
      var template = mixedWithStock
        ? (CFG.strings.shipTogetherMixed || CFG.strings.shipTogether || '')
        : mixedDates
          ? (CFG.strings.shipTogether || '')
          : (CFG.strings.shipPreorder || '');
      if (!template) return;
      var msg = esc(template).replace('{{ shipping }}', function () { return esc(shipping); });
      el.innerHTML = '<p class="lcd__together-msg">' + msg + '</p>';
      el.hidden = false;
    } catch (e) {
      console.error('[LCD] ship-together notice failed', e);
      if (el) { try { el.hidden = true; } catch (e2) { /* nothing else to try */ } }
    }
  }
  // Task 5: discount code field
  function applyDiscount(code) {
    // Shopify sets a session discount via the /discount/<code> route, then we re-read the cart.
    return fetch('/discount/' + encodeURIComponent(code), { method: 'GET' })
      .then(function () { return refresh(); })
      .catch(function (err) { console.error('[LCD] discount failed', err); });
  }
  // The code field is folded behind "Got a discount code?" — James, 2026-08-28: on an
  // iPhone SE the drawer's furniture took 95% of the screen and left 33px for the cart
  // itself, and an always-open field most customers never use was 75px of that.
  //
  // Built once rather than on every render. renderDiscount runs on each cart change, so
  // rebuilding would throw away a half-typed code and snap the panel shut under someone
  // mid-entry — a bug the old markup already had, and one that folding it away would have
  // made considerably more annoying.
  function renderDiscount(cart) {
    var el = root.querySelector('[data-lcd-discount]');
    if (!el) return;

    if (!el.querySelector('[data-lcd-disc-form]')) {
      el.innerHTML =
        '<details class="lcd__disc">' +
          '<summary class="lcd__disc-toggle">' + esc(CFG.strings.discountToggle) + '</summary>' +
          '<form class="lcd__disc-form" data-lcd-disc-form>' +
            '<input type="text" name="code" placeholder="' + esc(CFG.strings.discountPlaceholder) + '" autocomplete="off">' +
            '<button type="submit">' + esc(CFG.strings.discountApply) + '</button>' +
          '</form>' +
        '</details>' +
        '<p class="lcd__disc-applied" data-lcd-disc-applied hidden></p>';
      var form = el.querySelector('[data-lcd-disc-form]');
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var code = form.code.value.trim();
        if (code) applyDiscount(code);
      });
    }

    // The applied note sits outside the fold, so a code already on the cart stays visible
    // without the customer having to open anything to find out.
    var applied = (cart.cart_level_discount_applications || []).map(function (d) { return d.title; });
    var note = el.querySelector('[data-lcd-disc-applied]');
    if (note) {
      note.hidden = !applied.length;
      note.textContent = applied.length ? applied.join(', ') + ' — ' + CFG.strings.discountNote : '';
    }
  }
  // "Complete the look" — the band-matched hard case for whatever bands are in the cart,
  // plus the accessories offered whatever the band. Which items those are is decided by
  // legends-cart-upsell.js, which is pure and unit-tested; this only draws them and
  // performs the add. Everything it needs is already in the config the page rendered, so
  // unlike the carousel this replaced it makes no network call to open the drawer.
  function renderUpsells(cart) {
    var el = root.querySelector('[data-lcd-upsell]');
    if (!el) return;
    var offers = (window.LegendsCartUpsell && CFG.upsell)
      ? window.LegendsCartUpsell.computeUpsells(cart, CFG.upsell)
      : [];
    if (!offers.length) { el.hidden = true; el.innerHTML = ''; return; }
    el.hidden = false;
    el.innerHTML = '<h3 class="lcd__recs-title">' + esc(CFG.strings.recsTitle) + '</h3><div class="lcd__recs-row">' +
      offers.map(function (o) {
        var img = o.image
          ? '<img src="' + esc(o.image) + '" alt="" loading="lazy">'
          : '<img alt="" hidden>';
        // Two controls, deliberately: the tile opens the product page so a customer can
        // decide whether they want it, and the plus adds it. They cannot be one element —
        // an <a> and a <button> may not nest — and they must not be one target, because
        // James, 2026-08-28, wants the case reachable as well as addable.
        //
        // The plus is drawn small to suit the site, but its BUTTON is 44px so it can be hit
        // on a phone; the red square is drawn in the corner of that target rather than being
        // the target. Sizing lives in the stylesheet, not here.
        //
        // The plan rides on the button rather than being looked up at click time, so the
        // line lands in the same delivery group as the frames it was offered against.
        var plan = o.sellingPlanId == null ? '' : ' data-plan="' + esc(o.sellingPlanId) + '"';
        return '<div class="lcd__rec">' +
          '<a class="lcd__rec-link" href="' + esc(o.url) + '">' +
          '<span class="lcd__rec-img">' + img + '</span>' +
          '<span class="lcd__rec-t">' + esc(o.title) + '</span>' +
          '<span class="lcd__rec-p">' + formatMoney(o.price) + '</span>' +
          '</a>' +
          '<button class="lcd__rec-add" type="button" data-variant="' + esc(o.variantId) + '"' + plan +
          ' aria-label="' + esc(CFG.strings.upsellAdd + ': ' + o.title) + '">' +
          '<span class="lcd__rec-plus" aria-hidden="true">+</span></button>' +
          '</div>';
      }).join('') + '</div>';
  }
  var upsellEl = root.querySelector('[data-lcd-upsell]');
  if (upsellEl) {
    upsellEl.addEventListener('click', function (e) {
      var add = e.target.closest('.lcd__rec-add'); if (!add) return;
      // The button sits over the tile's link, so a tap that lands on it must not also
      // follow the link out to the product page.
      e.preventDefault();
      e.stopPropagation();
      var plan = add.getAttribute('data-plan');
      addVariant(parseInt(add.getAttribute('data-variant'), 10), 1, plan ? parseInt(plan, 10) : null);
    });
  }

  window.LCD_afterRender = function (cart) { renderShip(cart); renderTogether(cart); renderDiscount(cart); renderUpsells(cart); };

  var API = { open: open, close: close, refresh: refresh, addVariant: addVariant };
  window.LegendsCartDrawer = API;
  window.LCD_CONFIG = CFG;

  // Both free-case script tags are deferred and run in order, so LegendsFreeCase is
  // already present and the body is parsed by the time this runs.
  initCartPageResync();
  initBadgeSync();
})();
